export const LOCAL_STORAGE_TOKEN = "auth_token";
export const LOCAL_STORAGE_REFRESH_TOKEN = "auth_refresh_token";
